import { Component, OnInit } from '@angular/core';
import {clothColors} from '../clothColors';
import {ActivatedRoute} from '@angular/router';
import {TopicService} from '../topic.service';
import {MessageService} from '../../shared/message.service';
import {GeneralClairvoyantColorComponent} from '../g-clairvoyant-color.component';

@Component({
  selector: 'app-clairvoyant-color-bits',
  templateUrl: './clairvoyant-color-bits.component.html',
  styleUrls: ['./clairvoyant-color-bits.component.css']
})
export class ClairvoyantColorBitsComponent extends GeneralClairvoyantColorComponent {

  clothBits: number[] = [];
  bitSolution: number[];

  constructor(activatedRoute: ActivatedRoute, topicService: TopicService, messageService: MessageService) {
    super(activatedRoute, topicService, messageService);
    this.printable = true;
  }

  initValues() {
    super.initValues();
    this.clothBits = [];
  }

  setSolution (capShirtShortColor: clothColors[]) {
    this.solution = capShirtShortColor;
  }

  setBitSolution(bitSol: number[]) {
    this.bitSolution = bitSol;
  }

  turnCard() {
    console.log(this.clothBits);
    console.log(this.bitSolution);
    if (this.compareArrays(this.bitSolution, this.clothBits)) {
      this.isOneCardTurned = true;
    } else {
      this.messageService.addAlertWithTimeout('Tabelle falsch ausgefüllt!', 'danger', 2000);
    }
  }
}
